export default __webpack_public_path__ + "images/ceiling-fan-2.aeb683e4467ef003ce8fb6ef27ceeaf9.png";